import sprite from '../assets/icons.svg?url';

/** The icon sprite under a name with the build's hash: a new icon is never hidden by a sprite the browser kept
 * (Cloudflare tells browsers to keep an .svg 4 hours whatever nginx says). */
export const SPRITE = sprite;

/** An icon from src/assets/icons.svg (ids without the "i-" prefix). */
export function Icon({ name, size = 16, className = 'ico' }: { name: string; size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} aria-hidden="true">
      <use href={`${SPRITE}#i-${name}`} />
    </svg>
  );
}
